export const CINCO_MB = 5242880;